import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { Helmet } from '@dr.pogodin/react-helmet'

import { Button, Card, CardContent, CircularProgress, Divider, Grid, Typography } from '@mui/material'
import ConvertiblesApi from '../../../../api/ConvertiblesApi'
import ShareSelect from '../../../../components/entities/ShareSelect'

const AdminConvertibleNewForm = () => {
    const [saving, setSaving] = useState(false)
    const navigate = useNavigate()
    const formMethods = useForm()
    const convertiblesApi = new ConvertiblesApi()

    const handleCreateConvertible = async () => {
        if (saving) return
        setSaving(true)
        const data = formMethods.getValues()
        data.shareId = data.share?.id
        delete data.share
        // set all fields to null if empty string
        Object.keys(data).forEach((key) => {
            if (data[key] === '') data[key] = null
        })
        const newConvertible = await convertiblesApi.create(data)
        navigate(`/admin/convertibles/${newConvertible.id}`)
        setSaving(false)
    }

    return (
        <>
            <Helmet title='Ny konvertibel' />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'block',
                }}
            >
                Ny konvertibel
            </Typography>
            <Divider sx={{ my: 6 }} />
            <FormProvider {...formMethods}>
                <Card sx={{ mb: 6 }}>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 9, xl: 11 }}>
                                <ShareSelect />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 3, xl: 1 }}
                                sx={{
                                    alignContent: 'center',
                                }}
                            >
                                <Button
                                    variant='contained'
                                    color='primary'
                                    fullWidth
                                    onClick={() => {
                                        void handleCreateConvertible()
                                    }}
                                    disabled={saving}
                                >
                                    Skapa {saving && <CircularProgress size={24} />}
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </FormProvider>
        </>
    )
}

export default AdminConvertibleNewForm
